import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import { PROMETHEAN_BLUE, PROMETHEAN_DARK_PURPLE, PROMETHEAN_LIGHT_PURPLE, PROMETHEAN_NEUTRAL_DARK_GREY, PROMETHEAN_NEUTRAL_GREY_PLUM, PROMETHEAN_NEUTRAL_WHITE, PROMETHEAN_PURPLE_GRAPE, PROMETHEAN_TEXT, PROMETHEAN_ERROR_OR_DESTRUCT, PROMETHEAN_DESTRUCT_STATE_1, PROMETHEAN_DESTRUCT_STATE_2 } from '../styles/colors/colors';
import { PROMETHEAN_TYPOGRAPHY_BODY_LINK, PROMETHEAN_TYPOGRAPHY_SMALL_TEXT_LINK } from '../styles/typography/typography';
var COLOR_MAP = {
  white: {
    normal: PROMETHEAN_BLUE,
    hover: PROMETHEAN_DARK_PURPLE,
    visited: PROMETHEAN_PURPLE_GRAPE,
    disabled: PROMETHEAN_NEUTRAL_DARK_GREY,
    focus: PROMETHEAN_BLUE,
    loading: PROMETHEAN_TEXT
  },
  light: {
    normal: PROMETHEAN_TEXT,
    hover: PROMETHEAN_DARK_PURPLE,
    visited: PROMETHEAN_PURPLE_GRAPE,
    disabled: PROMETHEAN_NEUTRAL_DARK_GREY,
    focus: PROMETHEAN_BLUE,
    loading: PROMETHEAN_TEXT
  },
  dark: {
    normal: PROMETHEAN_NEUTRAL_WHITE,
    hover: PROMETHEAN_NEUTRAL_GREY_PLUM,
    visited: PROMETHEAN_LIGHT_PURPLE,
    disabled: PROMETHEAN_DARK_PURPLE,
    focus: PROMETHEAN_NEUTRAL_WHITE,
    loading: PROMETHEAN_NEUTRAL_WHITE
  },
  error: {
    normal: PROMETHEAN_ERROR_OR_DESTRUCT,
    hover: PROMETHEAN_DESTRUCT_STATE_2,
    visited: PROMETHEAN_DESTRUCT_STATE_1,
    disabled: PROMETHEAN_NEUTRAL_DARK_GREY,
    focus: PROMETHEAN_BLUE,
    loading: PROMETHEAN_TEXT
  }
};
var LinkBaseStyle = function LinkBaseStyle(_ref) {
  var mode = _ref.mode;
  return {
    '&:focus-visible': {
      padding: '0 3px',
      marginLeft: -3,
      marginRight: -3,
      outlineStyle: 'solid',
      outlineWidth: 2,
      outlineOffset: -3,
      outlineColor: COLOR_MAP[mode].focus
    },
    '&:hover': {
      color: COLOR_MAP[mode].hover
    },
    '&:visited': {
      color: COLOR_MAP[mode].visited,
      '&:hover': {
        color: COLOR_MAP[mode].hover
      }
    },
    '&-small': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SMALL_TEXT_LINK), {}, {
      color: COLOR_MAP[mode].normal
    }),
    '&-loading': {
      textDecoration: 'none',
      color: COLOR_MAP[mode].loading,
      cursor: 'default',
      display: 'inline-flex',
      lineHeight: '24px',
      '&:focus-visible': {
        outline: 'none'
      },
      '&:visited': {
        color: COLOR_MAP[mode].loading
      },
      '&:hover': {
        color: COLOR_MAP[mode].loading
      },
      '.EmbersLink-loading-icon': {
        color: COLOR_MAP[mode].loading,
        marginRight: 8
      }
    },
    '&-disabled': {
      color: COLOR_MAP[mode].disabled,
      cursor: 'not-allowed',
      '&:focus-visible': {
        outline: 'none'
      },
      '&:visited': {
        color: COLOR_MAP[mode].disabled
      },
      '&:hover': {
        color: COLOR_MAP[mode].disabled
      },
      '.EmbersLink-loading-icon': {
        color: COLOR_MAP[mode].disabled
      }
    }
  };
};
export var StyledLink = styled('a')(function (_ref2) {
  var mode = _ref2.mode;
  return {
    '&.EmbersLink': _objectSpread(_objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_BODY_LINK), {}, {
      display: 'inline-block',
      color: COLOR_MAP[mode].normal,
      width: 'fit-content'
    }, LinkBaseStyle({
      mode: mode
    })), {}, {
      '&-button': {
        position: 'relative',
        WebkitTapHighlightColor: 'transparent',
        backgroundColor: 'transparent',
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: 'pointer',
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        '&::-moz-focus-inner': {
          borderStyle: 'none' // Remove Firefox dotted outline.
        }
      }
    })
  };
});

export var StyledLinkButton = styled('span')(function (_ref3) {
  var _ref3$mode = _ref3.mode,
    mode = _ref3$mode === void 0 ? 'white' : _ref3$mode;
  return {
    '&.EmbersButtonLink': _objectSpread(_objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_BODY_LINK), {}, {
      display: 'inline-flex',
      width: 'fit-content',
      textDecoration: 'none',
      color: COLOR_MAP[mode].normal,
      alignItems: 'center'
    }, LinkBaseStyle({
      mode: mode
    })), {}, {
      '.EmbersButtonLink-icon': {
        fontSize: 24,
        // color: COLOR_MAP[mode].normal,
        marginRight: 4
      },
      '&:hover': {
        color: COLOR_MAP[mode].hover,
        '.EmbersButtonLink-icon': {
          color: COLOR_MAP[mode].hover
        }
      },
      '&-disabled': _objectSpread(_objectSpread({}, LinkBaseStyle({
        mode: mode
      })['&-disabled']), {}, {
        'span.EmbersButtonLink-icon': {
          color: COLOR_MAP[mode].disabled
        },
        '&:hover': {
          color: COLOR_MAP[mode].disabled,
          '.EmbersButtonLink-icon': {
            color: COLOR_MAP[mode].disabled
          }
        }
      })
    })
  };
});